class P4Functions {
  constructor() {}

  init() {
    // TODO: Common
    new CustomSlideUp();
    gsap.registerPlugin(ScrollTrigger);

    // TODO: P4 Header
    this.p4Header();

    // TODO: P4 Unit
    this.p4Unit();

    // TODO: P4 Lumbar
    this.p4Lumbar();

    // TODO: P4 Angle
    this.p4Angle();

    // TODO: P4 3d2d
    this.p43d2d();

    // TODO: P4 Pillow
    this.p4Pillow();

    // TODO: P4 Steel
    this.p4Steel();
  }

  p4Header() {
    const controller = new DataVideoController();
    controller.init();
  }

  p4Unit() {
    const p4Slides = document.querySelectorAll('#p4-unit .swiper-slide');

    p4Slides.forEach(function (slide) {
      const defaultMedia = slide.querySelector('.media-box:not(.media-box-different)');
      const differentMedia = slide.querySelector('.media-box.media-box-different');
      const tabBtns = slide.querySelectorAll('.p4-unit-tab-btn');

      if (!defaultMedia || !differentMedia || tabBtns.length === 0) return;

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const type = this.dataset.type;

          tabBtns.forEach(function (b) {
            b.classList.remove('active');
          });
          this.classList.add('active');

          if (type === 'different') {
            defaultMedia.classList.remove('active');
            differentMedia.classList.add('active');
          } else {
            differentMedia.classList.remove('active');
            defaultMedia.classList.add('active');
          }
        });
      });
    });
  }

  p4Lumbar() {
    if(window.innerWidth > 768) {
      ScrollTrigger.create({
        trigger: '#p4-lumbar .container',
        pin: true,
        start: 'top top',
        end: '+=1000',
      });

      ScrollTrigger.create({
        trigger: '#p4-lumbar .container',
        scrub: true,
        start: 'top top',
        end: '+=1000',
        animation: gsap
          .timeline()
          .to('#p4-lumbar .section-2', { opacity: 1 })
          .to('#p4-lumbar .section-2 .title', { duration: 3, fontSize: '56rem' }, '<')
          .to('#p4-lumbar .section-3', { opacity: 1 }),
      });
    }
  }

  p4Angle() {
    if (window.innerWidth > 768) {
      ScrollTrigger.create({
        trigger: ".p4-back-section-1",
        start: "top center",
        end: "top top",
        scrub: true,
        animation: gsap.timeline().to(".p4-back-section-1 video", {
          width: '1380rem',
          height: '650rem',
          borderRadius: '8rem',
          duration: 3,
        }),
      });
    }
  }

  p43d2d() {
    this.p43d2dTagsFunction();

    if(window.innerWidth > 768) {
      this.p43d2dWwiperBox();
    }
  }

  p43d2dWwiperBox() {
    const cardBoxes = document.querySelectorAll('.p4-card-box');
    
    cardBoxes.forEach((cardBox, index) => {
      const cardIndex = index + 1;
      const leftSwiperEl = cardBox.querySelector('.swiper-p4-left');
      const rightSwiperEl = cardBox.querySelector('.swiper-p4-right');
      const paginationEl = cardBox.querySelector(`#p4-card-pagination-${cardIndex}`);
      
      if (!leftSwiperEl || !rightSwiperEl || !paginationEl) return;
      
      const p4RightSwiper = new Swiper(rightSwiperEl, {
        loop: false,
        autoplay: false,
        on: {
          slideChange() {
            p4LeftSwiper.slideTo(this.activeIndex);
          },
        },
      });

      const p4LeftSwiper = new Swiper(leftSwiperEl, {
        loop: false,
        autoplay: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          bulletActiveClass: 'bullet-active',
          renderBullet: function (bulletIndex, className) {
            return `
              <div class="p4-point-bullet ${className}">
                <div class="bullet-content">
                  <p class="point-tit">
                    <i class="point-icon"></i>
                    ${paginationEl.dataset[`pointtit${bulletIndex+1}`]}
                  </p>
                  <p class="point-ctn">${paginationEl.dataset[`pointctn${bulletIndex+1}`]}</p>
                </div>
              </div>
            `;
          },
        },
        on: {
          slideChange() {
            p4RightSwiper.slideTo(this.activeIndex);
          },
        },
      });
    });
  }

  p43d2dTagsFunction() {
    const wWidth = window.innerWidth;
    const tag_1 = document.querySelector(".tag-1");
    const tag_2 = document.querySelector(".tag-2");
    const show_tag_1 = document.querySelector(".show-tag-1");
    const show_tag_2 = document.querySelector(".show-tag-2");
    const pc_card_1 = document.querySelector(".p4-card-box.card-1");
    const pc_card_2 = document.querySelector(".p4-card-box.card-2");
    const m_card_1 = document.querySelector(".p4-card-box-mobile.card-1");
    const m_card_2 = document.querySelector(".p4-card-box-mobile.card-2");

    const card_1 = wWidth > 768 ? pc_card_1 : m_card_1;
    const card_2 = wWidth > 768 ? pc_card_2 : m_card_2;

    const tag_1_text = tag_1.dataset.name;
    const tag_2_text = tag_2.dataset.name;

    if(wWidth > 768) {
      tag_1.innerHTML = tag_1_text;
      tag_2.innerHTML = tag_2_text;
    } else {
      tag_1.innerHTML = tag_1_text;
      tag_2.innerHTML = tag_2_text.split(" ")[0];
    }

    tag_1.addEventListener("click", function () {
      tag_1.classList.add("active");
      show_tag_1.classList.add("active");
      tag_2.classList.remove("active");
      show_tag_2.classList.remove("active");

      if (wWidth < 768) {
        tag_1.innerHTML = tag_1_text;
        tag_2.innerHTML = tag_2_text.split(" ")[0];
      }

      if (card_1) {
        card_1.classList.remove("hide");
      }
      
      if (card_2) {
        card_2.classList.remove("show");
      }
    })

    tag_2.addEventListener("click", function () {
      tag_2.classList.add("active");
      show_tag_2.classList.add("active");
      tag_1.classList.remove("active");
      show_tag_1.classList.remove("active");

      if (wWidth < 768) {
        tag_1.innerHTML = tag_1_text.split(" ")[0];
        tag_2.innerHTML = tag_2_text;
      }
      
      if (card_1) {
        card_1.classList.add("hide");
      }
      if (card_2) {
        card_2.classList.add("show");
      }
    })
  }

  p4Pillow() {
    const tagsBtn = document.querySelectorAll('#p4-pillow .tags .tag');
    const pillows = document.querySelectorAll('#p4-pillow .pillow-item');
    
    tagsBtn.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const ind = this.dataset.index;
        const pillowItem = document.querySelector(`#p4-pillow .pillow-item-${ind}`);
        
        tagsBtn.forEach(function(b) { b.classList.remove('active'); });
        pillows.forEach(function(c) { c.classList.remove('active'); });

        this.classList.add('active');
        pillowItem.classList.add('active');
      });
    });
  }

  p4Steel() {
    $('.p4-steel-box-pc-right .p4-steel-coll').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      $('.p4-steel-box-pc-left>div').eq($(this).index()).addClass('active').siblings().removeClass('active');
    });

    $('.p4-steel-coll-tabs p').click(function () {
      const tabs_p_parent_idx = $(this).parent().parent().parent().index();
      const tabs_p_idx = $(this).index();

      $(this).addClass('active').siblings().removeClass('active');
      $('.p4-steel-box-pc-left>div').eq(tabs_p_parent_idx).find('img').eq(tabs_p_idx).show().siblings().hide();
    });

    $('#btn-prev-p4-steel').addClass('disabled');

    const swiper_p4_steel = new Swiper('.swiper-p4-steel', {
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      slidesPerView: 1.1,

      on: {
        slideChangeTransitionStart: function () {
          let activeIndex = this.activeIndex;
          const isEnd = this.isEnd;
          if (isEnd) {
            $('#btn-next-p4-steel').addClass('disabled');
          } else {
            $('#btn-next-p4-steel').removeClass('disabled');
          }
          if (activeIndex > 0) {
            $('#btn-prev-p4-steel').addClass('active');
            $('#btn-prev-p4-steel').removeClass('disabled');
          } else {
            $('#btn-prev-p4-steel').removeClass('active');
            $('#btn-prev-p4-steel').addClass('disabled');
          }
        },
      },
    });

    $('#btn-prev-p4-steel').click(function () {
      swiper_p4_steel.slidePrev(200, true);
    });

    $('#btn-next-p4-steel').click(function () {
      swiper_p4_steel.slideNext(200, true);
    });
  }
}